import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { getAdjustedCargoTemperature, getAdjustedCargoTemperatureInTank } from './adjustedCargoTemperatureUtils';
import { getRange } from '../cargoOperationUtils';
import { isNullOrUndefined } from 'src/utils/objectUtils';

export const CARGO_TEMPERATURE_MIN = 0;
export const CARGO_TEMPERATURE_MAX = 100;

export const getDefaultCargoTemperature = (cargo: RotationCargo): number => {
    return cargo.product.voyageTemperatureRange.max;
};

export const getCargoTemperatureFromCommodityBook = (cargo: RotationCargo): number => {
    return cargo.temperature;
};

export const getCargoTemperature = (stowagePlan: StowagePlan, cargo: RotationCargo, tank?: Tank): number => {
    return (
        getAdjustedCargoTemperatureInTank(stowagePlan, cargo, tank)?.temperature ??
        getAdjustedCargoTemperature(stowagePlan, cargo)?.temperature ??
        getCargoTemperatureFromCommodityBook(cargo)
    );
};

export const getCorrectedVoyageTemperatureRange = (cargo: RotationCargo): string => {
    const _minRange = !isNullOrUndefined(cargo.productChanges?.voyageTemperatureRange?.min)
        ? cargo.productChanges?.voyageTemperatureRange?.min
        : cargo.product.voyageTemperatureRange.min;
    const _maxRange = !isNullOrUndefined(cargo.productChanges?.voyageTemperatureRange?.max)
        ? cargo.productChanges?.voyageTemperatureRange?.max
        : cargo.product.voyageTemperatureRange.max;

    return getRange(_minRange, _maxRange);
};
